var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", {
      staticClass: "ban",
      staticStyle: {
        "background-image":
          "url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg')",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "g-top" }, [
        _c("div", { staticClass: "tab" }, [
          _c("ul", [
            _c("li", { class: { on: _vm.activeTab === "company" } }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveTab("company")
                    },
                  },
                },
                [_vm._v("公司简介")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: { on: _vm.activeTab === "honors" } }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveTab("honors")
                    },
                  },
                },
                [_vm._v("公司荣誉")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cur" }, [
          _vm._v("\n        当前位置：\n        "),
          _c("a", { attrs: { href: "/" } }, [_vm._v("首页")]),
          _vm._v(" "),
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _vm._v("关于我们"),
          ]),
          _vm._v(" >\n        "),
          _vm.activeTab === "company"
            ? _c("span", [_vm._v("公司简介")])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab === "honors"
            ? _c("span", [_vm._v("公司荣誉")])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "company",
            expression: "activeTab === 'company'",
          },
        ],
        staticClass: "row-c1",
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "company",
            expression: "activeTab === 'company'",
          },
        ],
        staticClass: "row-c2",
      },
      [_vm._m(1)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "honors",
            expression: "activeTab === 'honors'",
          },
        ],
        staticClass: "row-b1",
      },
      [
        _c("div", { staticClass: "wp" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-r cccc is-pc" },
            [
              _c(
                "el-carousel",
                {
                  attrs: {
                    interval: 4000,
                    type: "card",
                    height: "220px",
                    arrow: "always",
                  },
                },
                _vm._l(_vm.images, function (item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index },
                    [
                      _c("el-image", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          src: item.carouselImg,
                          "preview-src-list": _vm.images.map(
                            (item) => item.carouselImg
                          ),
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "is-mobile" },
            [
              _c(
                "el-carousel",
                { attrs: { interval: 4000, height: "220px", arrow: "always" } },
                _vm._l(_vm.images, function (item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index },
                    [
                      _c("el-image", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          src: item.carouselImg,
                          "preview-src-list": _vm.images.map(
                            (item) => item.carouselImg
                          ),
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab === "jobs",
            expression: "activeTab === 'jobs'",
          },
        ],
        staticClass: "g-bgc1",
      },
      [_vm._m(3)]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "m-txt1" }, [
        _c("div", { staticClass: "about-content" }, [
          _c(
            "div",
            {
              staticClass: "txt wow fadeInLeft",
              attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.2s" },
            },
            [
              _c("h3", { staticClass: "tit" }, [
                _vm._v("北京西宝电子技术有限责任公司"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _c("p", [
                  _vm._v(
                    "北京西宝电子技术有限责任公司是从事微波毫米波产品研发和生产的高科技公司，地处北京中关村高科技开发区，设有微波研发部、微波制造部，拥有完善的生产能力和装调设施。"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                西宝公司的微波产品种类多，覆盖面广，涉及50MHz—300GHz各个频段。包括各种规格的微波器件和天线，有超强的系统配套和组合能力，能为客户提供整体方案。其中毫米波领域具有特别的技术优势，可根据客户需求研发、设计和生产各类产品。\n              "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "公司于2003年通过了ISO9001质量体系认证，确保公司产品质量管理体系的持续和改进。"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "西宝公司愿以精湛的设计、优异的加工、出色的产品、定制的服务使您在微波集成或应用领域展翅高飞、创造未来。"
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pic wow fadeInRight",
              attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.25s" },
            },
            [_c("img", { attrs: { src: "/images/p35.jpg", alt: "公司简介" } })]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "m-txt2" }, [
        _c(
          "div",
          {
            staticClass: "txt wow fadeInLeft",
            attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.2s" },
          },
          [
            _c("h3", { staticClass: "tit" }, [_vm._v("研发 · 沉淀 · 应用")]),
            _vm._v(" "),
            _c("div", { staticClass: "desc" }, [
              _c("p", [
                _vm._v(
                  "西宝公司经历了近三十年的发展过程，是研发、设计、生产和销售为一体的实体企业。公司与各大院校合作，成功完成了众多的科研配套任务，产品被广泛应用于通信、导航、气象和医疗等微波应用领域，得到业界的好评。"
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pic wow fadeInRight",
            attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.25s" },
          },
          [
            _c("img", {
              attrs: { src: "/images/p36.png", alt: "研发沉淀应用" },
            }),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-l" }, [
      _c("div", { staticClass: "m-t1" }, [
        _c("span", [_vm._v("Honor")]),
        _vm._v(" "),
        _c("h3", [_vm._v("公司荣誉")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-slider5" }, [
        _c("div", { staticClass: "slider" }, [
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "desc" }, [
              _vm._v(
                "\n                公司通过了ISO9001质量体系认证，确保公司产品质量管理体系的持续和改进。"
              ),
              _c("br"),
              _vm._v(
                " 西宝公司愿以精湛的设计、优异的加工、出色的产品、定制的服务使您在微波集成或应用领域展翅高飞、创造未来。\n              "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wp" }, [
      _c("ul", { staticClass: "m-list5" }, [
        _c("li", [
          _c("div", { staticClass: "con" }, [
            _c("div", { staticClass: "top" }, [
              _c("h3", { staticClass: "tit" }, [_vm._v("高级射频工程师")]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("span", { staticClass: "s1" }, [_vm._v("本科及以上")]),
                _vm._v(" "),
                _c("span", { staticClass: "s2" }, [_vm._v("3年以上")]),
                _vm._v(" "),
                _c("span", { staticClass: "s3" }, [_vm._v("北京")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "txt" }, [
              _c("h4", { staticClass: "t1" }, [_vm._v("任职资格 :")]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _c("p", [
                  _vm._v("1. 电子工程、通信工程等相关专业本科及以上学历；"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("2. 3年以上射频电路设计经验，熟悉微波器件原理；"),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("3. 熟练掌握ADS、HFSS等仿真软件；")]),
                _vm._v(" "),
                _c("p", [_vm._v("4. 具备良好的团队合作精神和沟通能力。")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bot" }, [
              _vm._v("投递邮箱：hr@beijingxibao.com"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "con" }, [
            _c("div", { staticClass: "top" }, [
              _c("h3", { staticClass: "tit" }, [_vm._v("天线设计工程师")]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("span", { staticClass: "s1" }, [_vm._v("硕士及以上")]),
                _vm._v(" "),
                _c("span", { staticClass: "s2" }, [_vm._v("2年以上")]),
                _vm._v(" "),
                _c("span", { staticClass: "s3" }, [_vm._v("北京")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "txt" }, [
              _c("h4", { staticClass: "t1" }, [_vm._v("任职资格 :")]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _c("p", [
                  _vm._v(
                    "1. 电磁场与微波技术、通信工程等相关专业硕士及以上学历；"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("2. 2年以上天线设计经验，熟悉各类天线原理与设计；"),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("3. 熟练使用CST、HFSS等电磁仿真软件；")]),
                _vm._v(" "),
                _c("p", [_vm._v("4. 具有较强的分析问题和解决问题的能力。")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bot" }, [
              _vm._v("投递邮箱：hr@beijingxibao.com"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }